import React from 'react'
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css';

const CalendarCmp = () => {
  return (
    <Calendar className="calendar"/>
  )
}

export default CalendarCmp